export const environment = {
    production: true,
    API_URL: 'https://back.consigue.corefluens.co/api/',
    enterprise: "consigue",
    api_username: 'consigue',
    api_password: 'DFpd4isaFHHT490',
    enable_seas: false
};
